import { render } from "./LocationDetails.vue?vue&type=template&id=18722b8d&scoped=true"
import script from "../js/location-details.js?vue&type=script&lang=js&external"
export * from "../js/location-details.js?vue&type=script&lang=js&external"

import "./LocationDetails.vue?vue&type=style&index=0&id=18722b8d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18722b8d"]])

export default __exports__